module.exports = __webpack_public_path__ + "static/media/hizli-abonelik.b77695b5.png";